export enum CriterioValidezEnum {
    at_least_eight_chars,
    at_least_one_lower_case_char,
    at_least_one_upper_case_char,
    at_least_one_digit_char,
    at_least_one_special_char,
}